import {
    SET_REPORT_TYPES,
    SET_PHASES,
    SET_PROGRAM_YEARS,
    SET_SECTIONS,
    SET_PROCEDURES,
    SET_REPORT_TYPE_ID,
    SET_PROGRAM_ID,
    SET_PROJECT_ID,
    SET_PHASE_ID,
    SET_PROGRAM_YEAR,
    SET_PROCEDURE_ID,
    SET_SELECTED_SECTIONS,
    RESET_PARAMETERS,
    NEXT_PAGE,
    PREVIOUS_PAGE,
    SET_PROJECT,
    SET_CURRENT_EVENT,
    SET_PREVIOUS_EVENT,
    SET_PHOTO_POINTS,
    SET_HIDE_PHOTO_POINT,
    SET_MONITORING_EVENT_ID,
    SET_PREVIOUS_EVENT_ID,
    SET_PHOTOS_LOADED,
    UPDATE_PHOTO,
} from "../Actions/Types/reportActionTypes";

const initialState = {
    reportTypes: [],
    phases: null,
    programYears: [],
    procedures: null,
    sections: [],
    reportTypeId: null,
    programId: null,
    projectId: null,
    phaseId: null,
    programYear: null,
    procedureId: 8,
    monitoringEventId: null,
    selectedSections: {},
    pageIndex: 0,

    // Photo Monitoring
    project: null,
    currentEvent: null,
    previousEvent: null,
    photoPoints: [],
    hidePhotoPoints: {},
};

export const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_REPORT_TYPES:
            return {
                ...state,
                reportTypes: action.reportTypes,
            };
        case SET_PHASES:
            return {
                ...state,
                phases: action.phases,
            };
        case SET_PROGRAM_YEARS:
            return {
                ...state,
                programYears: action.programYears,
                programYear: state.programYear ?? action.programYears?.[0]?.calendarYear
            };
        case SET_SECTIONS:
            return {
                ...state,
                sections: action.sections,
            };
        case SET_PROCEDURES:
            return {
                ...state,
                procedures: action.procedures,
            };
        case SET_REPORT_TYPE_ID:
            return {
                ...state,
                reportTypeId: action.reportTypeId,
            };
        case SET_PROGRAM_ID:
            return {
                ...state,
                programId: action.programId || null,
            };
        case SET_PROJECT_ID:
            return {
                ...state,
                phases: null,
                phaseId: null,
                sections: [],
                selectedSections: {},
                projectId: action.projectId || null,
            };
        case SET_PHASE_ID:
            return {
                ...state,
                sections: [],
                selectedSections: {
                    'riparian-habitat': [],
                    'instream-habitat': [],
                },
                phaseId: action.phaseId || null,
            };
        case SET_PROGRAM_YEAR:
            return {
                ...state,
                sections: [],
                selectedSections: {
                    'riparian-habitat': [],
                    'instream-habitat': [],
                },
                programYear: action.programYear || null,
            };
        case SET_PROCEDURE_ID:
            return {
                ...state,
                procedureId: action.procedureId || null,
            };
        case SET_HIDE_PHOTO_POINT:
            return {
                ...state,
                hidePhotoPoints: {
                    ...state.hidePhotoPoints,
                    [String(action.photoPointId)]: {
                        isCurrentHidden: action.isCurrentHidden,
                        isPreviousHidden: action.isPreviousHidden,
                    },
                },
            }   
        case SET_MONITORING_EVENT_ID:
            return {
                ...state,
                monitoringEventId: action.monitoringEventId || null,
            };
        case SET_PREVIOUS_EVENT_ID:
            return {
                ...state,
                previousEventId: action.previousEventId || null,
            };
        case SET_PROJECT:
            return {
                ...state,
                project: action.project,
            };
        case SET_CURRENT_EVENT:
            return {
                ...state,
                currentEvent: action.event,
            };
        case SET_PREVIOUS_EVENT:
            return {
                ...state,
                previousEvent: action.event,
            };
        case SET_PHOTO_POINTS:
            return {
                ...state,
                photoPoints: action.photoPoints,
            };
        case SET_PHOTOS_LOADED:
            return {
                ...state,
                photosLoaded: action?.photosLoaded ?? Array.from(document.querySelectorAll('div.photo img')).every(function (i) { return i.complete }),
            };
        case NEXT_PAGE:
            return {
                ...state,
                pageIndex: state.pageIndex + 1,
            };
        case PREVIOUS_PAGE:
            return {
                ...state,
                pageIndex: state.pageIndex - 1,
            };
        case SET_SELECTED_SECTIONS:
            return {
                ...state,
                selectedSections: action.selectedSections,
            };
        case UPDATE_PHOTO:
            const currentEvent = {
                ...state.currentEvent,
                Photos: [...state.currentEvent?.Photos ?? []].map(photo => {
                    if (photo.photoId === action.photo.photoId) {
                        return action.photo;
                    }
                    return photo;
                })
            };
            const previousEvent = {
                ...state.previousEvent,
                Photos: [...state.previousEvent?.Photos ?? []].map(photo => {
                    if (photo.photoId === action.photo.photoId) {
                        return action.photo;
                    }
                    return photo;
                })
            };
            return {
                ...state,
                currentEvent,
                previousEvent,
            };
        case RESET_PARAMETERS:
            return {
                ...initialState,
                ...action.parameters,
            };
        default:
            return state;
    }
};


